/**
 * Normalize worker / socket quote payloads for client merge.
 * Finnhub quote: c = current price, dp = percent change.
 * Worker POSTs { [ticker]: { change, price? } }.
 */

/**
 * Build a merge map from a raw marketUpdate object.
 * Only includes entries with a numeric change; attaches price when present and finite.
 */
export function normalizeQuoteUpdates(raw) {
  if (!raw || typeof raw !== 'object') return {};
  const out = {};
  for (const [ticker, quote] of Object.entries(raw)) {
    if (!quote || typeof quote !== 'object') continue;
    const change = quote.change;
    if (typeof change !== 'number' || Number.isNaN(change)) continue;
    const entry = { change };
    if (quote.price !== undefined && quote.price !== null) {
      const price = Number(quote.price);
      if (Number.isFinite(price)) entry.price = price;
    }
    out[ticker] = entry;
  }
  return out;
}

/**
 * Map a Finnhub quote JSON body to the worker push shape.
 * Mirrors treemap-fetcher.py so tests can assert the pipeline contract.
 */
export function finnhubQuoteToUpdate(data) {
  if (!data || typeof data !== 'object') return null;
  if (data.dp === undefined || data.dp === null) return null;
  const change = Math.round(Number(data.dp) * 100) / 100;
  if (Number.isNaN(change)) return null;
  const entry = { change };
  if (data.c !== undefined && data.c !== null) {
    const price = Math.round(Number(data.c) * 100) / 100;
    if (Number.isFinite(price)) entry.price = price;
  }
  return entry;
}
